module.exports = __webpack_public_path__ + "img/sauna.d823b61d.jpeg";